import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import * as CreDtos from "../../CRE.dtos";
import * as Config from '../../configuration/consts';
import { Form, Errors, LocalForm, Control, actions, Field } from 'react-redux-form'; 

@withRouter
export class ForumTag extends React.Component<any, any> {
        formDispatch;
        confirmDelete: boolean = false;
        constructor(props) {
            super(props);
            this.state = { showDetail: false, confirmDelete: false };

            this.onFilterClick = this.onFilterClick.bind(this);
            this.onToggleClicked = this.onToggleClicked.bind(this);
            this.onDeleteClicked = this.onDeleteClicked.bind(this);
            this.onLocalSubmit = this.onLocalSubmit.bind(this);
            this.onSubmit = this.onSubmit.bind(this);
        }
    
    componentDidUpdate(prevProps, prevState) {
        if (this.formDispatch && this.state.showDetail && this.props.filterItem) {
            this.formDispatch(actions.change('tag', this.props.filterItem));
        }
    }

    onLocalSubmit(values) {
        this.onSubmit(values);
    }

    async onSubmit(form) {
        if(form.name != undefined && form.name != ""){    
            let item = new CreDtos.ForumTag();
            item = {...form};
            item.type = this.props.type;
            item.pinned = !this.confirmDelete;
            this.props.saveTagRequest(this.props.forum.id, item);
            this.formDispatch(actions.reset('tag'));
        }
        this.onToggleClicked();
    }

    onToggleClicked() {
        this.setState({ showDetail: !this.state.showDetail });
    }

    onDeleteClicked() {
        this.confirmDelete = true;
        this.formDispatch(actions.submit('tag'));
    }
    
    onFilterClick(filter) {
        if (this.props.activeFilter && this.props.activeFilter.id === this.props.filterItem.id)
        {
            filter = { id: undefined, name: Config.VIEW_ALL, type: this.props.type };
        }
        this.props.activeTag(filter);
    }

    filterCss(active, theme) {
        let activeToggle = `btn btn-small btn-${theme}`;
        let inactiveToggle = `btn btn-small btn-${theme}-inactive`;
        return active ? activeToggle : inactiveToggle;
    }

    render() {

        const { location, children, title, filter, filterItem, forum, active, isAdmin, ...props } = this.props;
        let placeholderText = `Add new ${title}...`;

        /* The Delete / Unpin button is only visible non existing items */
        let deleteButton =  filterItem ? <a onClick={this.onDeleteClicked} style={{ maxWidth: "36px" }} className="input-group-addon btn btn-default clickable">
                                <span className="fa fa-unlink"></span>
                            </a> : undefined;

        let editForm = <LocalForm model="tag" className="tag-form" onSubmit={this.onLocalSubmit.bind(this)} getDispatch={(dispatch) => this.formDispatch = dispatch}>
                            <div className="discussion-board input-group">
                                <Control.text model=".name" className="form-control lightgrey-bg" placeholder={placeholderText} autoFocus={true} maxLength={14}/>
                                {deleteButton}
                                <button type="submit" style={{ maxWidth: "36px" }} className="input-group-addon btn btn-default">
                                    <span className="fa fa-check"></span>
                                </button>
                                <a onClick={this.onToggleClicked} style={{ maxWidth: "36px" }} className="input-group-addon btn btn-default">
                                    <span className="fa fa-times"></span>
                                </a>
                            </div>
                        </LocalForm>;

        let addTag = undefined;
        // Can only edit if it is ADMIN or not ALL
        let editFilter = isAdmin && filterItem.id ? <button type="button" style={{ width: "40px" }} className={this.filterCss(active, forum.themeColour)} onClick={this.onToggleClicked}>
                                        <span className="fa fa-ellipsis-v"></span>
        </button> : undefined;

        
        let filterName = filterItem ? filterItem.name.length > 14 ? `${filterItem.name.substr(0, 12)}&hellip;` : filterItem.name : "";

        if (filterItem) {
            addTag = this.state.showDetail ?
                editForm
                : <div className="btn-group">
                    <button type="button" onClick={this.onFilterClick.bind(this, filterItem)}
                        className={this.filterCss(active, forum.themeColour)}><span dangerouslySetInnerHTML={{ __html:filterName}}></span></button>
                    {editFilter}
                  </div>
                ;
        } else {
            addTag = this.state.showDetail ? <div className="my-2">{editForm}</div> :
                                                <button type="button" className="btn btn-default btn-block" onClick={this.onToggleClicked}>Add New {title}</button>;
        }
        return (addTag);
    }
}


// WEBPACK FOOTER //
// ./src/components/DiscussionBoard/ForumTag.tsx